import { Component, OnInit, Renderer2, ViewChild, HostListener, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import 'rxjs/add/operator/debounce';
import 'rxjs/add/operator/debounceTime';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-knob',
  templateUrl: './knob.component.html',
  styleUrls: ['./knob.component.css']
})
export class KnobComponent implements OnInit {

  mouseY = 0;
  mouseIsDown = false;
  rotation = 180;
  debouncer: Subject<any> = new Subject();

  @ViewChild('knob') el: ElementRef;
  @Output() output = new EventEmitter;
  @Input() init_value = 0;
  @Input() title;
  @HostListener('mousedown', ['$event'])
    public mouseDown(event) {
      this.mouseY = event.clientY;
      this.mouseIsDown = true;
    }
  @HostListener('document:mousemove', ['$event'])
    public onClick(event) {
      if (this.mouseIsDown) {
        this.rotate(event.clientY);
      }
    }
  @HostListener('document:mouseup', ['$event'])
    public onUp(event) {
      this.mouseIsDown = false;
    }
  // @HostListener('touchmove', ['$event'])
  // public gas(event) {
  //   console.log('gas', event);
  // }


  constructor(private renderer: Renderer2) {
    this.debouncer
        .debounceTime(50)
        .subscribe((val) => this.output.emit(val));
  }
  ngOnInit() {
    let f = this.init_value;
    this.rotation = (f * 360);
    f = f * 0.8;
    f += 0.1;
    this.renderer.setStyle(this.el.nativeElement, 'transform', 'rotate(' + (f * 360 + 180) + 'deg)');
  }

  onPanStart(event) {
    event.preventDefault();
    this.mouseY = event.center.y;
  }
  onPan(event) {
    event.preventDefault();
    this.rotate(event.center.y);
  }

  start(event) {
    this.mouseIsDown = true;
  }

  stop() {
    this.mouseIsDown = false;

  }

  rotateKnob() {

    let f = this.rotation / 360;
    this.output.emit(f);
    f = f * 0.8;
    f += 0.1;

    this.renderer.setStyle(this.el.nativeElement, 'transform', 'rotate(' + (f * 360 + 180) + 'deg)');

  }

  rotate(newY) {

    const diff = newY - this.mouseY;

    this.rotation -= diff * 2;
    if (this.rotation < 0) {
      this.rotation = 0;
    }
    if (this.rotation > 360) {
      this.rotation = 360;
    }
    this.mouseY = newY;
    this.rotateKnob();
  }
}





// WEBPACK FOOTER //
// ./src/app/knob/knob.component.ts